"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.get = void 0;
var data_model_info_1 = __importDefault(require("@mms-v3/data-model-info"));
/** @internal */
function get() {
    return data_model_info_1.default;
}
exports.get = get;
